import { useState } from 'react'
import { InputTitle, SelectButton } from 'theme/components'
import Network from 'type/Network'
import DefaultNetworkSVG from 'assets/images/default-network.svg'
import NetworksModal from 'components/NetworksModal'
import { NetworkLogo, NetworkName } from './Styled'
import { useSelectedToken } from 'state/token/hooks'
import { useSelectedNFTCollection } from 'state/nft/hooks'

interface NetworkSelectProps {
  selectedNetwork: Network | undefined
  otherNetwork: Network | undefined
  side: 'SOURCE' | 'TARGET'
  showTitle: boolean
  sourceText?: string
  targetText?: string
  requestClaim?: boolean
  nftBridge?: boolean
  onChange?: (network: Network) => void
}

function NetworkSelect(props: NetworkSelectProps): JSX.Element {
  const { selectedNetwork, otherNetwork, side, showTitle, sourceText, targetText, requestClaim, nftBridge, onChange } =
    props
  const selectedToken = useSelectedToken()
  const selectedNFTCollection = useSelectedNFTCollection()
  const [showNetworskModal, setShowNetworksModal] = useState(false)

  return (
    // @ts-ignore
    <div className={props.className}>
      {showTitle && (
        <InputTitle>
          {side == 'SOURCE' ? sourceText ?? 'DEPARTURE CHAIN' : targetText ?? 'DESTINATION CHAIN'}
        </InputTitle>
      )}
      {selectedNetwork ? (
        <SelectButton iconType="arrowDown" iconSide="right" onClick={() => setShowNetworksModal(true)}>
          <NetworkLogo src={selectedNetwork.logoURI ?? DefaultNetworkSVG} alt={selectedNetwork.name} />
          <NetworkName>{selectedNetwork.name}</NetworkName>
        </SelectButton>
      ) : (
        <SelectButton
          disabled={!requestClaim && ((!nftBridge && !selectedToken) || (nftBridge && !selectedNFTCollection))}
          iconType="arrowDown"
          iconSide="right"
          onClick={() => setShowNetworksModal(true)}
        >
          <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M4.68629 4.68629C7.68687 1.68571 11.7565 0 16 0C19.1 -0.00147771 22.1337 0.897644 24.7323 2.58807C27.3309 4.27849 29.3825 6.68741 30.6376 9.52199C31.8927 12.3566 32.2974 15.4947 31.8023 18.555C31.3073 21.6152 29.9339 24.4658 27.8491 26.7601C25.7643 29.0544 23.0579 30.6936 20.0589 31.4786C17.0599 32.2635 13.8975 32.1604 10.956 31.1816C8.01455 30.2028 5.42076 28.3907 3.48996 25.9653C1.55916 23.54 0.374503 20.606 0.0799999 17.52C0 17.0171 0 16.5143 0 16C0 11.7565 1.68571 7.68688 4.68629 4.68629ZM22.8914 21.1771C24.5039 21.5963 26.1626 21.8114 27.8286 21.8171L28.3771 21.7943C28.6497 21.2283 28.8826 20.644 29.0743 20.0457C27.1561 20.0929 25.2389 19.9203 23.36 19.5314C23.3589 19.0524 23.2286 18.5826 22.9829 18.1714C24.8848 15.687 26.2084 12.8095 26.8571 9.74857C27.4286 10.0152 27.9924 10.3124 28.5486 10.64C27.8474 8.99188 26.8301 7.49707 25.5543 6.24V7.38286C21.0625 5.85694 16.1881 5.88512 11.7143 7.46286C11.3604 7.10576 10.9127 6.85614 10.4229 6.74286H10.1371C10 6.26286 9.85143 5.64572 9.77143 5.29143C9.71796 5.05463 9.6798 4.81784 9.62626 4.48549C9.59969 4.3206 9.56933 4.13218 9.53143 3.90857C8.98769 4.20429 8.46458 4.53648 7.96571 4.90286C8.09143 5.30286 8.09143 5.47429 8.09143 5.63429C8.19429 6.13714 8.33143 6.62857 8.46857 7.12C8.03093 7.37915 7.6787 7.76072 7.45532 8.21765C7.23193 8.67458 7.14715 9.1869 7.21143 9.69143C5.40075 10.8876 3.78229 12.352 2.41143 14.0343C2.31044 14.6886 2.25697 15.3494 2.25143 16.0114V16.6629C3.91987 14.6232 5.83991 12.803 7.96571 11.2457C8.29483 11.5894 8.71073 11.8378 9.16942 11.9645C9.62811 12.0913 10.1125 12.0917 10.5714 11.9657C12.1069 14.5282 14.196 16.7149 16.6857 18.3657C17.1543 18.6743 17.6343 18.96 18.1143 19.2343C18.0661 19.6903 18.137 20.151 18.32 20.5714C16.2228 22.2391 13.8022 23.4533 11.2114 24.1371C10.964 23.6403 10.5674 23.2332 10.0772 22.9728C9.58706 22.7123 9.02776 22.6116 8.47752 22.6846C7.92728 22.7577 7.41361 23.0008 7.00834 23.3801C6.60306 23.7594 6.32644 24.2558 6.21714 24.8H5.46286C6.54487 26.0975 7.85861 27.1826 9.33714 28L9.66857 27.9314C10.1233 27.7822 10.5297 27.5137 10.8454 27.1538C11.161 26.794 11.3742 26.3561 11.4629 25.8857C14.3851 25.1405 17.1133 23.7764 19.4629 21.8857C20.021 22.2119 20.68 22.32 21.3131 22.1891C21.9461 22.0583 22.5083 21.6978 22.8914 21.1771ZM12.4836 10.0629C12.5761 9.71437 12.5943 9.35031 12.537 8.99431C16.6716 7.58392 21.1608 7.60808 25.2799 9.06289C24.723 11.9664 23.507 14.7034 21.7256 17.0629C21.2273 16.8519 20.6757 16.8012 20.1473 16.9179C19.619 17.0347 19.14 17.313 18.777 17.7143C18.6338 17.6219 18.4831 17.5295 18.3286 17.4348C18.1011 17.2953 17.8656 17.1509 17.6342 16.9943C15.3271 15.455 13.4004 13.4111 11.9999 11.0172C12.2262 10.7365 12.391 10.4114 12.4836 10.0629Z"
              fill="currentColor"
            />
          </svg>
          <span>Select</span>
        </SelectButton>
      )}
      {showNetworskModal && (
        <NetworksModal
          title="Select a blockchain"
          side={side}
          selectedNetwork={selectedNetwork}
          otherNetwork={otherNetwork}
          onDismiss={() => setShowNetworksModal(false)}
          requestClaim={requestClaim}
          nftBridge={nftBridge}
          selectNetworkCallback={onChange}
        />
      )}
    </div>
  )
}

export default NetworkSelect
